const LENGTHS = {
  ascii: [160, 306, 459],
  unicode: [70, 134, 201],
};

// const cut: true,
const MAX_SMS_NUM = 3;

export function calculateSmsLenghtAndCount(text, additionalLength = 0) {
  var smsType,
    smsLength = additionalLength,
    smsCount = -1,
    charsLeft = 0,
    isUnicode = false;

  for (var charPos = 0; charPos < text.length; charPos++) {
    switch (text[charPos]) {
      case "\n":
      case "[":
      case "]":
      case "\\":
      case "^":
      case "{":
      case "}":
      case "|":
      case "€":
        smsLength += 2;
        break;

      default:
        smsLength += 1;
    }
    if (text.charCodeAt(charPos) > 127 && text[charPos] !== "€")
      isUnicode = true;
  }

  smsType = isUnicode ? LENGTHS.unicode : LENGTHS.ascii;

  var match = false;
  var cutStrLength = 9999;
  for (var sCount = 0; sCount < MAX_SMS_NUM; sCount++) {
    cutStrLength = smsType[sCount] - additionalLength;
    if (smsLength <= smsType[sCount]) {
      smsCount = sCount + 1;
      charsLeft = smsType[sCount] - smsLength;
      match = true;
      break;
    }
  }

  if (!match)
    return {
      text: text.substring(0, cutStrLength),
      smsCount: MAX_SMS_NUM,
      charsLeft: 0,
    };

  return {
    text: text,
    smsCount: smsCount,
    charsLeft: charsLeft,
  };
}

export function smsContainsUrl(text) {
  return /(http:\/\/|https:\/\/|www\.)\S+/i.test(text);
}
